import {Component, Inject, Prop, Vue, Watch} from 'vue-property-decorator'
import {ActiveInject} from "@/support/reactive"

@Component
export default class TableCellClassifiableMixin extends Vue {
    @ActiveInject({from: 'jds.table.cell.classifier'}) classifier!: Vue;

    classifyAsInTable(type: string) {
        if (this.classifier) {
            this.classifier.$emit('inform', type);
        }
    }
}
